import { render, staticRenderFns } from "./EditBulletinDialog.vue?vue&type=template&id=45b4d079&"
import script from "./EditBulletinDialog.vue?vue&type=script&lang=js&"
export * from "./EditBulletinDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports